import { Grid } from '@backstage/ui';
import { EntityLayout } from './entity-layout';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../core/i18n';
import layoutStyles from './layouts.module.css';
import {
  EntityWarningContent,
  GroupProfileCard,
  OwnershipCard,
  MembersListCard,
  LinksCard,
} from '../components';

export const GroupEntityLayout = () => {
  const { t } = useTranslationRef(appTranslationRef);

  return (
    <EntityLayout>
      <EntityLayout.Route path="/" title={t('entity.tabs.overview')}>
        <Grid.Root columns="12" gap="3" className={layoutStyles.gridStretch}>
          <EntityWarningContent />
          <Grid.Item colSpan={{ xs: '12', md: '6' }}>
            <GroupProfileCard />
          </Grid.Item>
          <Grid.Item colSpan={{ xs: '12', md: '6' }}>
            <OwnershipCard />
          </Grid.Item>
          <Grid.Item colSpan={{ xs: '12', md: '6' }}>
            <MembersListCard />
          </Grid.Item>
          <Grid.Item colSpan={{ xs: '12', md: '6' }}>
            <LinksCard />
          </Grid.Item>
        </Grid.Root>
      </EntityLayout.Route>
    </EntityLayout>
  );
};
